import styled from 'styled-components';
import { Media } from 'enums';
import { ZIndex } from 'config';

export const AvatarStyled = styled.div`
  border-radius: 50%;
  height: 32px;
  width: 32px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  z-index: ${ZIndex.BlockingScreen};

  @media ${Media.notebook} {
    height: 56px;
    width: 56px;
  }

  & img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
`;
